<div class="d-flex filters-head-div d-md-none d-lg-none">
  <div class="filters-heading me-2">Filters</div>
  <mat-chip class="reset-chip" (click)="resetFilters()">
    <img
      src="/assets/images/job-filters-reset.svg"
      alt="job-filters-reset"
      class="me-1"
    />Reset
  </mat-chip>
</div>

  <section class="job-filters-section p-3">
    <div>
      <div>
        <div class="d-none d-md-block d-lg-block">
          <div class="filters-head-div">
          <div class="filters-heading me-2">Filters</div>
          <mat-chip class="reset-chip" (click)="resetFilters()">
            <img
              src="/assets/images/job-filters-reset.svg"
              alt="job-filters-reset"
              class="me-1"
            />Reset
          </mat-chip>
        </div></div>
        <div class="card mt-3" style="height: 95%">
          <div class="card-body">
            <form [formGroup]="filterForm">
              <div
                class="filter-field-container"
                *ngIf="filterColumns?.includes('Products')"
              >
                <div class="filter-label mb-3">
                  {{ heading }}
                </div>
                <mat-chip-grid #chipList>
                  <div *ngFor="let controlName of filterControls">
                    <ng-container *ngIf="isArray(filterForm.get(controlName)?.value); else singleChip">
                      <mat-chip-row
                        *ngFor="let item of filterForm.get(controlName)?.value"
                        class="reset-chip"
                        [class.d-none]="item === true || item === 'true'"
                        [selectable]="selectable"
                        [removable]="removable"
                        (removed)="remove(controlName, item)"
                      >
                      {{ (isCatalogSection)? (item | truncateText: 18 | titlecase) : (isCategoryFilter() ? getProductName(item) : item) | truncateText: 8 }}
                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                      </mat-chip-row>
                    </ng-container>
                
                    <ng-template #singleChip>
                      <mat-chip-row
                        *ngIf="filterForm.get(controlName)?.value"
                        class="reset-chip"
                        [selectable]="selectable"
                        [removable]="removable"
                        (removed)="remove(controlName, filterForm.get(controlName)?.value)"
                      >
                        {{ filterForm.get(controlName)?.value }}
                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                      </mat-chip-row>
                    </ng-template>
                  </div>
                </mat-chip-grid>
                <div class="input-wrapper" style="position: relative;" #searchContainer class="searchByKeyword">
                  <label class="input-container w-100">
                    <mat-icon matPrefix class="inp">search</mat-icon>
                    <input
                    matInput
                    [matChipInputFor]="chipList"
                    placeholder="Search By Keyword"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="add('keywords', $event)"
                    (input)="searchSuggestionDebounce($event)"
                     (click)="toggleSuggestions(); $event.stopPropagation()" autocomplete="new-password"
                  /> 
                  </label>
                  
                  <div *ngIf="isSugestionOpen" class="search-suggestions">
                    <ul>
                      <li *ngFor="let suggestion of searchSuggestions">
                        <p  (click)="selectedSuggestion(suggestion)"> {{ suggestion.name }} </p>
                      
                      </li>
                    </ul>
                  </div>
                </div>
                </div>
  
              <div
                class="filter-field-container"
                *ngIf="filterColumns?.includes('Region')"
              >
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title class="filter-label">Region</mat-panel-title>
                  </mat-expansion-panel-header>
  
                  <mat-form-field appearance="outline" class="input-font w-100">
                    <input
                      #autoCompleteCountryInput
                      matInput
                      [matAutocomplete]="countryAuto"
                      placeholder="Search for country"
                      [formControl]="countryControl"
                    />
                    <mat-autocomplete
                      #countryAuto="matAutocomplete"
                      (optionSelected)="onOptionSelected($event, 'country')"
                    >
                      <mat-option
                        *ngFor="let country of filteredCountries"
                        [value]="country"
                      >
                        {{ country.countryName }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
  
                  <mat-form-field appearance="outline" class="input-font w-100">
                    <input
                      #autoCompleteStateInput
                      matInput
                      [matAutocomplete]="stateAuto"
                      placeholder="Search for state"
                      [formControl]="stateControl"
                    />
                    <mat-autocomplete
                      #autoCompleteInput
                      #stateAuto="matAutocomplete"
                      (optionSelected)="onOptionSelected($event, 'state')"
                    >
                      <mat-option
                        *ngFor="let state of filteredStates"
                        [value]="state"
                      >
                        {{ state.stateName }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
  
                  <mat-form-field appearance="outline" class="input-font w-100">
                    <input
                      #autoCompleteInput
                      matInput
                      [matAutocomplete]="cityAuto"
                      placeholder="Search for city"
                      [formControl]="cityControl"
                    />
                    <mat-autocomplete
                      #cityAuto="matAutocomplete"
                      (optionSelected)="onOptionSelected($event, 'city')"
                    >
                      <mat-option
                        *ngFor="let city of filteredCities"
                        [value]="city"
                      >
                        {{ city.cityName }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
  
                  <mat-form-field appearance="outline" class="input-font w-100">
                    <input
                      #autoCompleteInput
                      matInput
                      multiple
                      placeholder="Filter By Zip Code"
                      formControlName="zipCode"
                    />
                  </mat-form-field>
                </mat-expansion-panel>
  
              </div>
              <div class="filter-field-container"  *ngIf="isCatalogSection">
                <mat-expansion-panel (click)="closeDropDown($event)">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="filter-label">
                      Products
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="products-info-field">
                    <mat-form-field appearance="outline" class="input-font w-100 products-field-container">
                      <input matInput placeholder="Search Products" (input)="searchCatalogRelatedProducts($event)" (focus)="openDropDown()">
                    </mat-form-field>
                    <div class="products-select-container" [ngClass]="{'open': isProductsDropDownOpen}">
                      <div *ngFor="let product of filteredProductCatalogData; let i = index" [attr.data-value]="product?.productInfoId" class="product-checkbox" (click)="selectProductCheckBox($event, product)">
                        <input [checked]="(filterForm.get('catalogProducts')?.value && filterForm.get('catalogProducts')?.value.includes(product?.productName)) ? true : false" type="checkbox" [name]="'checkbox' + i">
                        <span>{{ product?.productName | titlecase }}</span>
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
              </div>
  
              <div *ngIf="params.name !== 'brands'" class="filter-field-container">
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title class="filter-label">
                            Brands
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-form-field appearance="outline" class="input-font w-100">
                        <input matInput [matAutocomplete]="brandsAuto" placeholder="Search for Brands" [formControl]="brandControl" />
                        <mat-autocomplete #brandsAuto="matAutocomplete" (optionSelected)="onOptionSelected($event, 'brand')">
                            <mat-option *ngFor="let brand of filteredBrands" [value]="brand">
                                {{ brand.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </mat-expansion-panel>
            </div>
  
              <div *ngIf="heading !== 'Explore Distributors'"> 
                <div *ngFor="let spec of filterSpecifications; let i = index">
                  <mat-expansion-panel class="spec-panel" >
                    <mat-expansion-panel-header>
                      <mat-panel-title class="filter-label">{{ spec?.specificationName }}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-container *ngIf="spec?.specificationType === 'Text'; else numberTemplate">
                      <mat-form-field appearance="outline" class="input-font w-100 selectFormField">
                        <mat-select
                          multiple
                          placeholder="Filter By {{ spec?.specificationName }}"
                          [formControlName]="spec?.specificationName"
                          #filterMatSelect
                          >
                            <mat-option *ngFor="let value of (spec?.textValues || []);"  [value]="value | titlecase">
                              {{ value | titlecase }}
                            </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-container>
                    <ng-template #numberTemplate>
                      <mat-slider
                        min="{{ spec?.numberValues?.min }}"
                        max="{{ spec?.numberValues?.max }}"
                        class="w-100"
                      >
                        <input matSliderStartThumb [formControlName]="spec?.specificationName + 'From'" />
                        <input matSliderEndThumb [formControlName]="spec?.specificationName + 'To'" />
                      </mat-slider>
                      <p style="margin-bottom: 8px;">
                        {{ filterForm.get(spec?.specificationName + 'From')?.value || spec?.numberValues?.min }} {{ spec?.fromUnit }} -
                        {{ filterForm.get(spec?.specificationName + 'To')?.value || spec?.numberValues?.max }} {{ spec?.fromUnit }}
                      </p>
                      <div class="button-container">
                        <button class="mwe-button mwe-button--primary med-world-basic-font med-world-basic-font__medium ps-3 pe-3"
                        [disabled]="filterForm.get(spec?.specificationName + 'From')?.pristine && filterForm.get(spec?.specificationName + 'To')?.pristine"
  
                        (click)="applyFilter()">Submit</button>
                      </div>                </ng-template>
                  </mat-expansion-panel>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>